import buttonStyle from '../../../../materialUI/components/CustomButtons/buttonStyle'

const styles = {
  layout: {
    paddingTop: '30px',
    alignItems: 'left',
    width: '50%',
    height: '100%',
  },
  title: {
    paddingLeft: '0',
  },
  inputField: {
    marginTop: '0px',
    minWidth: '100%',
    'z-index': 0,
    '& input, & label': { height: '40px' },
  },
  ...buttonStyle,
  servicedAreaContainer: {
    width: '100%',
    backgroundColor: 'transparent',
  },
  servicedChipContainer: {
    marginBottom: '10px',
    marginRight: '5px',
  },
  servicedChip: {
    width: 'auto',
  },
  labelColour: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
}

export default styles
